import React from "react";
import { Link } from "react-router-dom";
import { useCollege } from "store/utils/hooks";

export interface LogoProps {
  className?: string;
  imgClassName?: string;
}

const Logo: React.FC<LogoProps> = ({
  className = "flex-shrink-0",
  imgClassName = "",
}) => {
  const college = useCollege()
  const img = college.logo;
  const imgLight = college.logo;

  return (
    <Link
      to="/"
      className={`ttnc-logo inline-block text-slate-600 ${className}`}
    >
      {/* THIS USE FOR MY CLIENT */}
      {/* PLEASE UN COMMENT BELLOW CODE AND USE IT */}
      {img ? (
        <img
          className={`block max-h-8 sm:max-h-10 ${
            imgLight ? "dark:hidden" : ""
          } ${imgClassName}`}
          src={img}
          alt="Logo"
        />
      ) : (
        "Logo Here"
      )}
      {imgLight && (
        <img
          className={`hidden max-h-8 sm:max-h-10 dark:block ${imgClassName}`}
          src={imgLight}
          alt="Logo-Light"
        />
      )}
    </Link>
  );
};

export default Logo;
